import PropTypes from 'prop-types';
import React from 'react';
import { getComponentClasses } from '@99designs/common/utils/app';
import { Spinner } from '@99designs/common/components/Spinner';

const OverviewMenuItem = ({ icon, href, text, variations, value, isUpdating, isInactive }) => {
    const updatedVariations = variations.slice();

    if (isInactive) {
        updatedVariations.push('inactive');
    }

    return (
        <li
            className={getComponentClasses('overview-menu-item', updatedVariations)}
            role="menuitem"
        >
            <a className="overview-menu-item__action" href={href}>
                {renderIcon(icon)}

                <span className="overview-menu-item__action__label">{text}</span>

                {renderValue(value, isUpdating, isInactive)}
            </a>
        </li>
    );
};

function renderIcon(icon) {
    if (icon) {
        return <span className="overview-menu-item__action__icon">{icon}</span>;
    }

    return null;
}

function renderValue(value, isUpdating, isInactive) {
    if (isUpdating && !isInactive) {
        return (
            <span className="overview-menu-item__action__value">
                <Spinner variations={['small', 'inline']} />
            </span>
        );
    }

    if (value) {
        return <span className="overview-menu-item__action__value">{value}</span>;
    }

    return null;
}

OverviewMenuItem.propTypes = {
    icon: PropTypes.element,
    value: PropTypes.element,
    href: PropTypes.string,
    variations: PropTypes.array,
    isUpdating: PropTypes.bool,
    isInactive: PropTypes.bool,
};

OverviewMenuItem.defaultProps = {
    icon: null,
    value: null,
    href: null,
    variations: [],
    isUpdating: false,
    isInactive: false,
};

export default OverviewMenuItem;
